import { formatTime, convertIntervalToDeltaDH, specialCharsDecode, formatTrueFalse } from '../../components/helpers.js'
import { REQUEST_PRIORITIES } from '../../forms/Request/Request.js'

function formatOrigin (value) {
  if (value === 'internal') {
    return 'Внутренняя'
  } else if (value === 'external') {
    return 'Внешняя'
  }
  return ''
}

function formatTargetProgram (value) {
  return value.filter(val => val != null).join(', ')
}

function formatReinforcements (value) {
  return value != null ? value.map(val => val.name + ` (${val.riStateName})`).join(',\n') : null
}

function formatRequestPriority (value) {
  if (value == null) {
    return null
  } else {
    const priority = REQUEST_PRIORITIES.find(priority => priority.value === value)
    return priority ? priority.name : value
  }
}

export const tasksTabColumns = {
  data: function () {
    let columns = [
      {
        name: 'objectNumber',
        label: 'Номер объекта',
        labelTable: 'Номер</br>объекта',
        align: 'center',
        field: 'objectNumber',
        sortable: true
      },
      {
        name: 'fvfComplexNumber',
        label: 'Номер комплекса',
        align: 'left',
        field: 'fvfComplexNumber',
        sortable: true
      },
      {
        name: 'checkoutStatus',
        label: 'Условие выезда',
        align: 'left',
        field: 'checkoutStatus',
        sortable: true
      },
      {
        name: 'conductorConnectionStatus',
        label: 'Статус ДК Дирижёр',
        labelTable: 'Статус<br/>ДК Дирижёр',
        align: 'center',
        field: 'conductorConnectionStatus',
        sortable: true
      },
      {
        name: 'deltaId',
        label: 'Идентификатор в Д2',
        labelTable: 'Идентификатор</br> в Д2',
        align: 'center',
        field: 'deltaId',
        sortable: true
      },
      {
        name: 'visId',
        label: 'Идентификатор в ВИС',
        labelTable: 'Идентификатор</br> в ВИС',
        align: 'center',
        field: 'visId',
        sortable: true
      },
      {
        name: 'cityMessengerBotRequestId',
        label: 'ID заявки в боте',
        labelTable: 'ID заявки</br>в боте',
        align: 'center',
        field: 'cityMessengerBotRequestId',
        sortable: true,
        defaultWidth: 80
      },
      {
        name: 'externalName',
        label: 'Номер/название в ВИС',
        labelTable: 'Номер/название</br>в ВИС',
        align: 'center',
        defaultWidth: 150,
        field: 'externalName',
        sortable: true
      },
      {
        name: 'objectType',
        label: 'Тип объекта',
        labelTable: 'Тип</br>объекта',
        align: 'center',
        field: 'objectType',
        sortable: true
      },
      {
        name: 'type',
        label: 'Тип заявки',
        align: 'center',
        field: 'type',
        sortable: true
      },
      {
        name: 'initialSource',
        label: 'Источник данных заявки',
        labelTable: 'Источник</br>данных</br>заявки',
        align: 'center',
        field: 'initialSource',
        sortable: true
      },
      {
        name: 'applicantDescr',
        label: 'Описание от заявителя',
        align: 'center',
        field: 'applicantDescr',
        defaultWidth: 350,
        sortable: true,
        columnFormat: 'expand'
      },
      {
        name: 'comment',
        label: 'Последний комментарий сменного',
        align: 'center',
        field: 'comment',
        defaultWidth: 250,
        sortable: true,
        format: specialCharsDecode
      },
      {
        name: 'totalPriority',
        label: 'Приоритет заявки',
        labelTable: 'Приоритет</br>заявки',
        align: 'center',
        field: 'totalPriority',
        sortable: true,
        format: formatRequestPriority
      },
      {
        name: 'bpStateName',
        label: 'Статус заявки',
        align: 'center',
        field: 'bpStateName',
        sortable: true
      },
      {
        name: 'reportBPStateName',
        label: 'Статус последнего отчёта по заявке',
        labelTable: 'Статус</br>последнего отчёта</br>по заявке',
        align: 'center',
        field: 'reportBPStateName',
        sortable: false
      },
      {
        name: 'brigadeName',
        label: 'Бригада',
        align: 'center',
        field: 'brigadeName',
        defaultWidth: 84,
        sortable: false
      },
      {
        name: 'brigadeEmployees', // Устаревшее значение. Осталось для обратной совместимости с настройкой колонок таблицы
        label: 'Исполнители',
        labelTable: 'Исполнители',
        align: 'center',
        field: 'executors',
        defaultWidth: 110,
        sortable: false,
        columnFormat: 'objects',
        columnObjectType: 'employee'
      },
      {
        name: 'reinforcements',
        label: 'Исполнители на усиление',
        labelTable: 'Исполнители на усиление',
        align: 'center',
        field: 'reinforcements',
        format: formatReinforcements,
        defaultWidth: 150,
        sortable: false
      },
      {
        name: 'requiredAnotherPerformerTranslation',
        label: 'Требуется перевод на другого исполнителя',
        labelTable: 'Требуется перевод на другого исполнителя',
        align: 'center',
        field: 'requiredAnotherPerformerTranslation',
        sortable: true,
        format: formatTrueFalse
      },
      {
        name: 'assignedDispatcher',
        label: 'Сменный',
        align: 'center',
        field: 'assignedDispatcher',
        defaultWidth: 100,
        sortable: false,
        columnFormat: 'object',
        columnObjectType: 'employee'
      },
      {
        name: 'statusVisName',
        label: 'Статус заявки в Roads',
        labelTable: 'Статус заявки</br>в Roads',
        align: 'center',
        defaultWidth: 104,
        field: 'statusVisName',
        sortable: true
      },
      {
        name: 'needExportToRoads',
        label: 'Подлежит экспорту в Roads',
        labelTable: 'Подлежит экспорту</br>в Roads',
        align: 'center',
        defaultWidth: 104,
        field: 'needExportToRoads',
        sortable: true,
        format: formatTrueFalse
      },
      {
        name: 'autoAcceptedToWorkRoads',
        label: 'Автоматически принята в работу в Roads',
        labelTable: 'Автоматически принята</br>в работу в Roads',
        align: 'center',
        defaultWidth: 104,
        field: 'autoAcceptedToWorkRoads',
        sortable: true,
        format: formatTrueFalse
      },
      {
        name: 'inventNumber',
        label: 'Инвентаризационный номер',
        labelTable: 'Инвентаризационный</br>номер',
        align: 'center',
        field: 'inventNumber',
        defaultWidth: 100,
        sortable: true
      },
      {
        name: 'exportImportStatus',
        label: 'Статус экспорта/импорта в Roads',
        labelTable: 'Статус экспорта/импорта</br>в работу в Roads',
        align: 'center',
        defaultWidth: 104,
        field: 'exportImportStatus',
        sortable: true,
        format: val => val ? val.alias : null
      },
      {
        name: 'origin',
        label: 'Внешняя/внутренняя заявка',
        labelTable: 'Внешняя/внутренняя</br>заявка',
        align: 'center',
        field: 'origin',
        sortable: false,
        format: formatOrigin
      },
      {
        name: 'objectAddress',
        label: 'Адрес объекта',
        align: 'center',
        defaultWidth: 200,
        field: 'objectAddress',
        sortable: true
      },
      {
        name: 'stationName',
        label: 'Станция метро',
        labelTable: 'Станция</br>метро',
        align: 'center',
        field: 'stationName',
        defaultWidth: 170,
        sortable: true
      },
      {
        name: 'lineName',
        label: 'Линия метро',
        labelTable: 'Линия</br>метро',
        align: 'center',
        field: 'lineName',
        defaultWidth: 90,
        sortable: true
      },
      {
        name: 'controllerType',
        label: 'Тип контроллера',
        labelTable: 'Тип</br>контроллера',
        align: 'center',
        field: 'controllerType',
        defaultWidth: 170,
        sortable: true
      },
      {
        name: 'boiSn',
        label: 'Серийный номер БОИ',
        labelTable: 'Серийный</br>номер БОИ',
        align: 'center',
        field: 'boiSn',
        sortable: true
      },
      {
        name: 'cameraModel',
        label: 'Модель камеры',
        labelTable: 'Модель</br>камеры',
        align: 'center',
        field: 'cameraModel',
        sortable: true
      },
      {
        name: 'redirectedWorkArea',
        label: 'Заявка переведена на',
        labelTable: 'Заявка</br>переведена на',
        align: 'center',
        field: 'redirectedWorkArea',
        sortable: false
      },
      {
        name: 'targetProgram',
        label: 'Целевая программа',
        labelTable: 'Целевая</br>программа',
        align: 'center',
        field: 'targetProgram',
        format: formatTargetProgram,
        sortable: false
      },
      {
        name: 'createTime',
        label: 'Дата/время создания заявки',
        labelTable: 'Дата/время</br>создания заявки',
        align: 'center',
        field: 'createTime',
        sortable: true,
        format: formatTime
      },
      {
        name: 'changeTime',
        label: 'Дата/время изменения заявки',
        labelTable: 'Дата/время</br>изменения заявки',
        align: 'center',
        field: 'changeTime',
        sortable: true,
        format: formatTime
      },
      {
        name: 'bpLastStateTime',
        label: 'Дата/время изменения статуса заявки',
        labelTable: 'Дата/время</br>изменения статуса</br>заявки',
        align: 'center',
        field: 'bpLastStateTime',
        sortable: true,
        format: formatTime
      },
      {
        name: 'endWorkTime',
        label: 'Дата/время завершения работ по заявке',
        labelTable: 'Дата/время</br>завершения работ</br>по заявке',
        align: 'center',
        field: 'endWorkTime',
        sortable: true,
        format: formatTime
      },
      {
        name: 'closeConditionTime',
        label: 'Срок выполнения заявки',
        labelTable: 'Срок</br>выполнения</br>заявки',
        defaultWidth: 110,
        align: 'center',
        field: 'closeConditionTime',
        sortable: true,
        format: (value, row) => {
          let activeByState = false
          if (row.activeByState || row.activeByState == null) {
            activeByState = true
          }
          if (value && activeByState) {
            const timeText = formatTime(value)
            const currentTime = new Date().getTime()
            if (value < currentTime) {
              return timeText + ' (прошло ' + convertIntervalToDeltaDH(value, currentTime) + ')'
            } else {
              return timeText + ' (осталось ' + convertIntervalToDeltaDH(value, currentTime) + ')'
            }
          }
        }
      },
      {
        name: 'alarms',
        label: 'НШС',
        defaultWidth: 350,
        align: 'center',
        field: 'alarms',
        sortable: false
        // format: (alarms, row) => {
        //   if (row.alarmSeverity != null && alarms.length) {
        //     return alarms.map(alarm => alarm.message).join('\n')
        //   }
        // }
      },
      {
        name: 'number',
        label: 'Номер заявки в Д2',
        labelTable: 'Номер</br>заявки в Д2',
        align: 'center',
        field: 'number',
        sortable: true
      },
      {
        name: 'adjacentAwaitingRequestCount',
        label: 'Число заявок на смежных объектах, ожидающих назначение',
        labelTable: 'Число заявок на смежных объектах,</br>ожидающих назначение',
        align: 'center',
        field: 'adjacentAwaitingRequestCount',
        sortable: false
      },
      {
        name: 'lastObjectCommonComment',
        label: 'Последний комментарий к объекту',
        labelTable: 'Последний комментарий к объекту',
        align: 'center',
        field: 'lastObjectCommonComment',
        sortable: false
      },
      {
        name: 'departuresCount',
        label: 'Число выездов по заявке',
        labelTable: 'Число выездов</br>по заявке',
        align: 'center',
        field: 'departuresCount',
        sortable: true
      },
      {
        name: 'project',
        label: 'Проект',
        labelTable: 'Проект',
        align: 'center',
        field: 'project',
        sortable: true
      },
      {
        name: 'forkliftTruck',
        label: 'Требуется автовышка',
        align: 'center',
        field: 'forkliftTruck',
        sortable: true,
        format: (value, row) => {
          if (!value) {
            return row.forkliftTruckRequired ? 'Да' : null
          }
          return value
        },
        columnFormat: 'object',
        columnObjectType: 'vehicle'
      },
      {
        name: 'zabbixMonitoringStatus',
        label: 'Статус объекта Zabbix',
        align: 'left',
        field: 'zabbixMonitoringStatus',
        sortable: true
      },
      {
        name: 'zabbixMonitoringSwitchStatus',
        label: 'Коммутатор связи',
        align: 'left',
        field: 'zabbixMonitoringSwitchStatus',
        sortable: true
      },
      {
        name: 'synchronizeSourceRequest',
        label: 'Синхронизирующая заявка',
        align: 'left',
        field: 'synchronizeSourceRequest',
        sortable: true
      },
      {
        name: 'synchronizeTargetRequest',
        label: 'Синхронизируемая заявка',
        align: 'left',
        field: 'synchronizeTargetRequest',
        sortable: true
      },
      {
        name: 'spdTaskType',
        label: 'Тип задачи ПТК АПТС',
        align: 'left',
        field: 'spdTaskType',
        sortable: true
      },
      {
        name: 'spdTaskStatus',
        label: 'Статус задачи ПТК АПТС',
        align: 'left',
        field: 'spdTaskStatus',
        sortable: true
      },
      {
        name: 'spdAssetNumber',
        label: 'Номер объекта инфраструктуры ПТК АПТС',
        align: 'left',
        field: 'spdAssetNumber',
        sortable: true
      },
      {
        name: 'spdBeaconId',
        label: 'ID маяка ПТК АПТС',
        align: 'left',
        field: 'spdBeaconId',
        sortable: true
      },
      {
        name: 'requestInitiator',
        label: 'Инициатор',
        align: 'left',
        field: 'requestInitiator',
        sortable: true
      },
      {
        name: 'rejectReopen',
        label: 'Отказик есть',
        align: 'left',
        field: 'rejectReopen',
        sortable: true,
        format: formatTrueFalse
      },
      {
        name: 'wasEnabledRejectReopen',
        label: 'Отказик был',
        align: 'left',
        field: 'wasEnabledRejectReopen',
        sortable: true,
        format: formatTrueFalse
      }
    ]

    const user = this.$store && this.$store.getters && this.$store.getters.getUser
    const hasAccessCheck = user && typeof user.hasUIAccess === 'function'

    if (hasAccessCheck && !user.hasUIAccess('request.displayInternalData')) {
      const availableColumnsKeys = new Set(['deltaId', 'number', 'type', 'objectType', 'objectNumber', /* 'fvfComplexNumber', */ 'objectAddress', 'objectRegion', 'applicantDescr', 'bpStateName', 'createTime', 'changeTime', 'endWorkTime', 'synchronizeTargetRequest'])

      columns = columns.filter(column => availableColumnsKeys.has(column.name))
    }

    return {
      formatTime: formatTime,
      columns
    }
  }
}
